import React, { useEffect, useState } from 'react';
import { fetchNews } from '../../utils/api';
import NewsCard from './NewsCard';
import './News.css';
import Layout from '../Layout/Layout';

const NewsPage = () => {
  const [articles, setArticles] = useState([]);
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const getNews = async () => {
      try {
        const data = await fetchNews();
        setArticles(data);
      } catch (err) {
        setError("Failed to fetch news. Please try again later.");
      }
    };
    getNews();
  }, []);

  const filteredArticles = articles.filter(article =>
    article.title.toLowerCase().includes(search.toLowerCase()) ||
    (article.author || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Layout>
      <div className="news-wrapper">
        <h2 className="news-title">📰 Latest News Feed</h2>
        <input
          type="text"
          placeholder="🔍 Search by title or author..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="news-search"
        />
        {error && <p className="news-error">{error}</p>}
        <div className="news-grid">
          {filteredArticles.map((article, idx) => (
            <NewsCard
              key={idx}
              title={article.title}
              author={article.author}
              date={article.publishedAt}
              description={article.description}
              url={article.url}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default NewsPage;
